module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "kp-btn-action-sm kp-btn__success",
    on: {
      "click": function($event) {
        return _vm.jumpAdd({
          options_ids: []
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-81099bca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/buttons/Add.vue
 ** module id = 880
 ** module chunks = 1
 **/